module.exports = __webpack_public_path__ + "static/media/default_project_logo.376c2210.png";